import { create } from "zustand";

export const useUserInterfaceStore = create((set) => ({
  // isPanelExpanded: true,
  // setIsPanelExpanded: (value) => set({ isPanelExpanded: value }),

  transformMode: "translate",
  setTransformMode: (transformMode) => set({ transformMode }),

  isTransforming: false,
  setIsTransforming: (isTransforming) => set({ isTransforming }),

  rotationAxes: { x: false, y: true, z: false },
  setRotationAxes: (axes) => set((state) => ({ rotationAxes: { ...state.rotationAxes, ...axes } })),

  showDesktopMovePanel: false,
  setShowDesktopMovePanel: (showDesktopMovePanel) => set({ showDesktopMovePanel }),

  playerMode: "editor",
  setPlayerMode: (playerMode) => set({ playerMode }),

  // Flag to indicate room data (config, decorations) is fully loaded
  roomDataLoaded: false,
  setRoomDataLoaded: (roomDataLoaded) => set({ roomDataLoaded }),

  editingRoom: false,
  setEditingRoom: (editingRoom) => set({ editingRoom }),

  roomEditingTab: 0, // 0 = Wall Type, 1 = Wall Decorations
  setRoomEditingTab: (roomEditingTab) => set({ roomEditingTab }),

  snappingForEditor: false,
  setSnappingForEditor: (snappingForEditor) => set({ snappingForEditor }),

  lockCameraForEditor: true,
  setLockCameraForEditor: (lockCameraForEditor) => set({ lockCameraForEditor }),

  showRoomLining: false,
  setShowRoomLining: (showRoomLining) => set({ showRoomLining }),

  autoRotateCamera: false,
  setAutoRotateCamera: (autoRotateCamera) => set({ autoRotateCamera }),

  decorationType: "image",
  decorationOption: null,
  decorationLink: "",
  decorationHoverText: "",
  decoration: null,
  selectedDecorationIndex: -1,

  setDecorationOption: (decorationOption) =>
    set((state) => ({
      decorationOption:
        decorationOption !== undefined
          ? decorationOption
          : state.decorationOption,
    })),

  setDecorationType: (decorationType) =>
    set((state) => ({
      decorationType:
        decorationType !== undefined ? decorationType : state.decorationType,
    })),

  setSelectedDecoration: (decoration = { type: "image" }, index = -1) =>
    set((state) => {
      const {
        type = state.decorationType,
        link = state.decorationLink,
        option = state.decorationOption,
        hoverText = state.decorationHoverText,
      } = decoration || {};

      return {
        decoration,
        selectedDecorationIndex: index,
        decorationType: type ?? state.decorationType,
        decorationLink: link ?? state.decorationLink,
        decorationOption: option ?? state.decorationOption,
        decorationHoverText: hoverText ?? state.decorationHoverText,
      };
    }),
  setDecorationLink: (decorationLink) => set({ decorationLink }),
  setDecorationHoverText: (decorationHoverText) => set({ decorationHoverText }),

  // Loading states for save/load operations
  isSaving: false,
  isLoading: false,
  lastSaveTime: null,
  saveError: null,

  // Shared session state
  isSharedSession: false,
  isReadOnlyMode: false,

  setIsSaving: (isSaving) => set({ isSaving }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setLastSaveTime: (timestamp) => set({ lastSaveTime: timestamp }),
  setSaveError: (error) => set({ saveError: error }),
  setIsSharedSession: (isShared) => set({ isSharedSession: isShared }),
  setIsReadOnlyMode: (isReadOnly) => set({ isReadOnlyMode: isReadOnly }),

  // Link indicator visibility (pulsing blue outline on clickable decorations)
  showLinkIndicators: true,
  setShowLinkIndicators: (showLinkIndicators) => set({ showLinkIndicators }),

  mobileEditMode: "assets",
  setMobileEditMode: (mode) => set({ mobileEditMode: mode }),
}));
